import ChatWidget from "./ChatWidget";
import Footer from "./Footer";
import Header from "./Header";
import "./WhyTredixo.css";

const WhyTredixo = () => {
  return (
    <>
    <Header />
    <main className="why-page">

      {/* HERO SECTION */}
      <section className="why-hero">
        <h1>Why Tredixo</h1>
        <p>
          Empowering all traders, Tredixo offers a comprehensive platform with
          professional tools, real-time data, and powerful analytics, all in a
          user-friendly interface.
        </p>
      </section>

      {/* ZERO BROKERAGE */}
      <section className="why-section">
        <h2>minimal  Brokerage</h2>
        <p className="subtitle">
          No More Sharing Your Profits, tredixo.store Lets You Keep It All
        </p>
      </section>

      {/* MARGIN TABLE */}
      <section className="why-section">
        <h2>Up to 500x Margin</h2>
        <p className="subtitle">
          Trade higher volumes with lesser capital.
        </p>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Script</th>
                <th>Per Lot Margin - Ordinary Platform</th>
                <th>Per Lot Margin - tredixo.store</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Gold</td>
                <td>Rs 5,50,000</td>
                <td>Rs 13,000</td>
              </tr>
              <tr>
                <td>Natural Gas</td>
                <td>Rs 65,000</td>
                <td>Rs 400</td>
              </tr>
              <tr>
                <td>Crude</td>
                <td>Rs 2,50,000</td>
                <td>Rs 1,500</td>
              </tr>
              <tr>
                <td>Silver</td>
                <td>Rs 3,00,000</td>
                <td>Rs 4,500</td>
              </tr>
              <tr>
                <td>Bank Nifty</td>
                <td>Rs 90,000</td>
                <td>Rs 1,500</td>
              </tr>
              <tr>
                <td>Nifty</td>
                <td>Rs 1,20,000</td>
                <td>Rs 2,500</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* MULTI MARKETS */}
      <section className="why-section">
        <h2>Multi Markets</h2>
        <p>
          Unify your global trading experience with our comprehensive platform,
          offering access to both national and international markets from a
          single streamlined interface.
        </p>
      </section>

      {/* CTA */}
      <section className="why-cta">
        <h2>Open Account in Just 1 Minute and Start Trading</h2>
        <p>
          Join tredixo.store now for the ultimate trading experience.
        </p>
        <button>Join Now</button>
      </section>
      {/* SUPPORT SECTION */}
<section className="support-section">
  <div className="support-card">
    <h2>Support Whenever You Need It</h2>
    <p>
      Our 24×7 customer support ensures you’re never alone, and your deposits
      and withdrawals are always smooth and efficient.
    </p>

    <a
      href="https://wa.me/8421371803"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-btn"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
      />
      Whatsapp Now
    </a>
  </div>
</section>


    </main>
    <Footer />
    <ChatWidget />
    </>
  );
};

export default WhyTredixo;
